import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { NavigationMenuSimpleComponent, NavigationComponent } from '@sirius/common';

@Component({
    selector: 'butterfly-navigation-wrapper',
    templateUrl: './navigation-wrapper.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NavigationMenuSimpleComponent, NavigationComponent]
})
export class NavigationWrapperComponent {
    @Input({ required: true }) content!: any;
}
